import axios from "axios";
import {db_url} from "../url";


export default function DB_News_Mailing(token) {

    const getNewsMailingList = (controller, page, size, search) => {
        return axios.get(db_url + `/admin/news_mailing?page=${page}&size=${size}&${search}`, {
            signal: controller.signal,
            headers: {
                Authorization: token
            }
        })
    }

    const getNewsMailing = (id) => {
        return axios.get(db_url + `/admin/news_mailing/${id}`, {
            headers: {
                Authorization: token
            }
        })
    }

    const sendNewsMailing = (data) => {
        return axios.post(db_url + `/admin/news_mailing`, data, {
            headers: {
                Authorization: token
            }
        })
    }

    return {
        getNewsMailingList,
        getNewsMailing,
        sendNewsMailing,
    }
}